<template>
  <div>
    <PendingBillingCases :selectedBilledStatuses="statuses"></PendingBillingCases>
  </div>
</template>
  
  <script>
const PendingBillingCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
import { defineAsyncComponent } from "vue";
export default {
  components: {
    PendingBillingCases,
  },
  data() {
    return {
      statuses: "Unbilled"
    };
  },
};
</script>
  